import React, { useRef, useState, useEffect } from "react"
import { MonthYearWheel, VisDiv } from '../components'
import { useStateContext } from '../context/StateContext'
import {FiEdit} from 'react-icons/fi'
import { usePreventScroll } from "react-aria"
import { screenPosition as screenPos} from '../lib/utils';


const Wheel = ({saveFn=()=>{}, wheelType = "monthYear", initialData}) =>{

    const {setShowLowbar, showLowbar, setDropdownScreenPosition, dropdownScreenPosition} = useStateContext()
    const [showContent, setShowContent] = useState()
    usePreventScroll({isDisabled: !showLowbar})
    const toggle = () => {

        if(!showLowbar){
            setDropdownScreenPosition(screenPos())
            window.scrollTo(0, 0);
        }
        if(showLowbar){
            window.scrollTo(0, dropdownScreenPosition);
        }
        setShowLowbar(!showLowbar)
        setShowContent(!showContent)
        
       
    }
    const save = (data) => {
        saveFn(data)
        window.scrollTo(0, dropdownScreenPosition);
        setShowLowbar(!showLowbar)
        setShowContent(!showContent)
    }
  return (
    <div>
        <VisDiv style={{marginLeft:"10px"}}>
            <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={toggle}>
                <FiEdit             
                size={15}
                color={"white"}/>
            </button>
        </VisDiv>
        <VisDiv className="lowbar-wrapper" rules={[showContent, wheelType == "monthYear"]}>
            <VisDiv onClick={(e)=>e.stopPropagation()} rules={[true]} className="lowbar-container">
                <MonthYearWheel wheelType={wheelType} initialData = {initialData} closeFn = {toggle} saveFn = {save}/>
            </VisDiv>
        </VisDiv>

       
    </div>
  )
}

export default Wheel
